import React from "react";

import { withRouter } from "react-router";
import { connect }    from "react-redux";

import * as qs          from 'utils/querystring';
import * as fromService from '@src/redux/modules/service';
import * as fromAliada  from '@src/redux/modules/aliada';

class InitService extends React.Component {
  componentDidMount() {
    const { pathname } = this.props.location;

    if (pathname.match(/^\/signup$/)) {
      this.parseServiceForSignUp();
    } else if (pathname.match(/^\/perfil\/\d+\/booking\/aliadas\/\d+\/reservar$/)) {
      this.parseServiceForBooking();
    }
  }

  parseServiceForSignUp() {
    const service = this.signUpParser();

    this.props.updateNewService({service});
    this.props.fetchAliada(service.aliadaId, {estimatedHours: service.estimatedHours,
                                              date: service.date,
                                              time: service.time,
                                              serviceTypeId: service.serviceTypeId});
  }

  parseServiceForBooking() {
    const service = this.bookingParser();

    this.props.updateNewService({service});
    this.props.fetchAliada(service.aliadaId, {estimatedHours: service.estimatedHours,
                                              date: service.date,
                                              time: service.time,
                                              serviceTypeId: service.serviceTypeId});
  }

  signUpParser() {
    const keys = [
      'serviceTypeId',
      'estimatedHours',
      'aliadaId',
      'date',
      'time',
    ];

    const { location } = this.props;

    const search = qs.parse(location.search);
    const next   = qs.parse(search.next.split("?")[1]);

    const service = Object.keys(next).reduce((acc, key) => {
      const isValidKey = keys.indexOf(key) !== -1

      if (isValidKey) {
        acc[key] = next[key]
      }

      return acc
    }, {});

    return service;
  }

  bookingParser() {
    const keys = [
      'serviceTypeId',
      'estimatedHours',
      'aliadaId',
      'date',
      'time',
    ];

    const { location } = this.props;

    const search = qs.parse(location.search.split("?")[1]);

    const service = Object.keys(search).reduce((acc, key) => {
      const isValidKey = keys.indexOf(key) !== -1

      if (isValidKey) {
        acc[key] = search[key]
      }

      return acc
    }, {});

    return service;
  }

  render() {
    return null;
  }
}

export default connect(
  null,
  {
    updateNewService: fromService.updateNewService,
    fetchAliada: fromAliada.fetchAliada,
  }
)(withRouter(InitService));



// WEBPACK FOOTER //
// ./src/screens/App/components/InitService/InitService.js